import { type FC } from 'react';
import classnames from 'classnames';
import dibsCss from 'dibs-css';

export const PipeSeparator: FC = () => {
    return (
        <span
            className={classnames(
                dibsCss.mxXxsmall,
                dibsCss.textDolphin,
                dibsCss.sassyFontBodySmall
            )}
        >
            |
        </span>
    );
};
